import React from 'react';
import cx from 'classnames';

import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';
import imageSectionStyles from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import MobileAppBadges from '../MobileAppBadges';
import styles from './FiveStarImageSection.module.less';

const FiveStarImageSection: React.FC = () => {
  const renderText = () => (
    <div className={imageSectionStyles.dek}>
      Who’s got time to hunch over a laptop? Download the iOS app our couples swear by and manage
      your registry anytime, anywhere.
    </div>
  );
  return (
    <ImageSection
      headerTag="h2"
      backgroundColor={bgColorOption.lightGray}
      title={<div className={imageSectionStyles.title}>5-Star App</div>}
      textPosition="right"
      borderBottom
      imageContents={
        <>
          <div className={cx(styles.secondaryImage)}>
            <span role="img" aria-label="custom photo background save the date card" />
          </div>
          {renderAsBackgroundImage({
            selector: `.${styles.secondaryImage}`,
            backgroundImageName: 'registry_benefits_five-star_app',
            directory: 'WeddingRegistryBenefitsLP/fiveStar',
            filetype: ['png', 'png', 'png'],
          })}
        </>
      }
      secondaryContents={renderText()}
      buttons={<MobileAppBadges />}
    />
  );
};

export default FiveStarImageSection;
